// src/services/api.js
// Centralized API base URL for backend requests

// Change this to your production URL when deploying
export const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://skylinemep.in/backend/api"
    : "http://localhost:8000/api";

export function getProjectsUrl(category, page) {
  const params = new URLSearchParams({ category, page });
  return `${API_BASE_URL}/projects.php?${params}`;
}

// Add more API endpoints as needed
